import sanitizeHtml from 'sanitize-html'

const SANITIZE_OPTIONS = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat([
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'img', 'figure', 'figcaption',
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'span', 'div', 'br', 'hr',
    'strong', 'em', 'u', 's', 'sub', 'sup',
  ]),
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    '*': ['style', 'class'],
    'a': ['href', 'target', 'rel'],
    'img': ['src', 'alt', 'width', 'height'],
    'td': ['colspan', 'rowspan'],
    'th': ['colspan', 'rowspan'],
  },
  allowedSchemes: ['http', 'https', 'mailto'],
}

export default function HtmlBlock({ chartOptions = {} }) {
  const html = chartOptions.html || ''
  const clean = sanitizeHtml(html, SANITIZE_OPTIONS)

  return (
    <div
      className="analytics-html-block"
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  )
}
